import { Alert, Typography } from "@mui/material";
import { config } from "../../../../../config";

import type { FC } from "react";

export const NoCustomDomainsMessage: FC = () => (
  <Alert severity="warning" sx={{ mt: 2 }}>
    <Typography variant="body2">
      {`You do not have any custom domains configured. By default all emails will be sent from '${config.defaultEmailFrom}'`}
    </Typography>
  </Alert>
);
